import { render, staticRenderFns } from "./RsaConfigurazionePaiDomiciliareAccessiCategorieListPage.vue?vue&type=template&id=423e7253"
import script from "./RsaConfigurazionePaiDomiciliareAccessiCategorieListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePaiDomiciliareAccessiCategorieListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports